import React, {Component} from 'react';
import {
    BrowserRouter,
    Route,
} from "react-router-dom";
import AppNavbar from "./components/AppNavbar";
import {Container} from "reactstrap";
import store from './store';
import {loadUser} from "./actions/authActions";
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import './App.scss';
import PropTypes from "prop-types";
import TaskContainer from "./containers/Tasks/TaskContainer";
import CreateTaskContainer from "./containers/Tasks/CreateTaskContainer";
import DetailTaskContainer from "./containers/Tasks/DetailTaskContainer";
import EditTaskContainer from "./containers/Tasks/EditTaskContainer";
import CustomerContainer from "./containers/Customers/CustomerContainer";
import CreateCustomerContainer from "./containers/Customers/CreateCustomerContainer";
import EditCustomerContainer from "./containers/Customers/EditCustomerContainer";
import DetailCustomerContainer from "./containers/Customers/DetailCustomerContainer";
import UserContainer from "./containers/Users/UserContainer";
import CreateUserContainer from "./containers/Users/CreateUserContainer";
import DetailUserContainer from "./containers/Users/DetailUserContainer";
import EditUserContainer from "./containers/Users/EditUserContainer";
import CreateDocumentContainer from "./containers/Documents/CreateDocumentContainer";
import MetaTags from 'react-meta-tags';


// Banner pour annoncer la nouvelle version
const NewVersionBanner = () => {
    const [isVisible, setIsVisible] = React.useState(true);

    if (!isVisible) return null;

    return (
        <div style={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            padding: '12px 20px',
            textAlign: 'center',
            position: 'sticky',
            top: 0,
            zIndex: 1050,
            boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '15px',
            flexWrap: 'wrap'
        }}>
            <span style={{ fontSize: '15px' }}>
                🎉 <strong>Nouveau !</strong> Découvrez notre nouveau design CRM avec plus de fonctionnalités !
            </span>
            <a 
                href="https://v2.crm-bmd.bittonmaterieldentaire.fr"
                style={{
                    background: 'white',
                    color: '#667eea',
                    padding: '8px 20px',
                    borderRadius: '25px',
                    textDecoration: 'none',
                    fontWeight: 'bold',
                    fontSize: '14px',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 2px 5px rgba(0,0,0,0.2)'
                }}
                onMouseOver={(e) => {
                    e.target.style.transform = 'scale(1.05)';
                    e.target.style.boxShadow = '0 4px 10px rgba(0,0,0,0.3)';
                }}
                onMouseOut={(e) => {
                    e.target.style.transform = 'scale(1)';
                    e.target.style.boxShadow = '0 2px 5px rgba(0,0,0,0.2)';
                }}
            >
                ✨ Essayer la V2
            </a>
            <button
                onClick={() => setIsVisible(false)}
                style={{
                    background: 'transparent',
                    border: 'none',
                    color: 'white',
                    fontSize: '20px',
                    cursor: 'pointer',
                    padding: '0 5px',
                    opacity: 0.7,
                    position: 'absolute',
                    right: '15px'
                }}
                onMouseOver={(e) => e.target.style.opacity = 1}
                onMouseOut={(e) => e.target.style.opacity = 0.7}
            >
                ×
            </button>
        </div>
    );
};


class App extends Component {


    static propTypes = {
        isAuthenticated: PropTypes.bool
    }

    componentDidMount() {
        store.dispatch(loadUser());
    }

    render() {
        return (
            <BrowserRouter>
                <div className="App">
                    <MetaTags>
                        <meta name="google" content="notranslate"/>
                    </MetaTags>
                    <NewVersionBanner />
                    <AppNavbar/>
                    <Container>
                            <Route path="/" exact component={TaskContainer}>
                            </Route>
                            <Route path="/createTask" component={CreateTaskContainer}>
                            </Route>
                            <Route path="/detailTask/:id" exact component={DetailTaskContainer}>
                            </Route>
                            <Route path="/editTask/:id" exact component={EditTaskContainer}>
                            </Route>
                            <Route path="/customerList" exact component={CustomerContainer}>
                            </Route>
                            <Route path="/createCustomer" exact component={CreateCustomerContainer}>
                            </Route>
                            <Route path="/detailCustomer/:id" exact component={DetailCustomerContainer}>
                            </Route>
                            <Route path="/detailCustomer/:id/createTask" component={CreateTaskContainer}>
                            </Route>
                            <Route path="/detailCustomer/:id/detailTask/:id" exact component={DetailTaskContainer}>
                            </Route>
                            <Route path="/detailCustomer/:id/editTask/:id" exact component={EditTaskContainer}>
                            </Route>
                            <Route path="/detailCustomer/:id/createDocument"  component={CreateDocumentContainer}>
                            </Route>
                            <Route path="/createDocument/:id"  component={CreateDocumentContainer}>
                            </Route>
                            <Route path="/editCustomer/:id" exact component={EditCustomerContainer}>
                            </Route>
                            <Route path="/userList" exact component={UserContainer}>
                            </Route>
                            <Route path="/createUser" exact component={CreateUserContainer}>
                            </Route>
                            <Route path="/detailUser/:id" exact component={DetailUserContainer}>
                            </Route>
                            <Route path="/detailUser/:id/createTask" component={CreateTaskContainer}>
                            </Route>
                            <Route path="/detailUser/:id/detailTask/:id" exact component={DetailTaskContainer}>
                            </Route>
                            <Route path="/detailUser/:id/editTask/:id" exact component={EditTaskContainer}>
                            </Route>
                            <Route path="/editUser/:id" exact component={EditUserContainer}>
                            </Route>
                    </Container>
                </div>
            </BrowserRouter>
        );
    }
}

export default App;
